/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loading } from "./AllReports";
import { calculateAge } from "./PatientsTable";
import { useHistory } from "react-router-dom";

const InsuranceTable = ({ data, initialLoad, sortingFunction }) => {
  const [lastNameOrder, setLastNameOrder] = useState(null);
  const [firstNameOrder, setFirstNameOrder] = useState(null);
  const [insuranceNameOrder, setInsuranceNameOrder] = useState(null);

  let history = useHistory();

  const viewDetail = (id) => {
    localStorage.setItem("master-location", "/patients3/insurance?return=true");
    history.push(`/patients3/${id}/insurance`);
  };

  const handleSort = (field) => {
    switch (field) {
      case "lastName":
        setFirstNameOrder(null);
        setInsuranceNameOrder(null);
        if (lastNameOrder === null) {
          setLastNameOrder(true);
          sortingFunction(["patient.family", "id"]);
        } else if (lastNameOrder) {
          setLastNameOrder(false);
          sortingFunction(["-patient.family", "id"]);
        } else {
          setLastNameOrder(null);
          sortingFunction(null);
        }
        break;
      case "firstName":
        setLastNameOrder(null);
        setInsuranceNameOrder(null);
        if (firstNameOrder === null) {
          setFirstNameOrder(true);
          sortingFunction(["patient.name", "id"]);
        } else if (firstNameOrder) {
          setFirstNameOrder(false);
          sortingFunction(["-patient.name", "id"]);
        } else {
          setFirstNameOrder(null);
          sortingFunction(null);
        }
        break;
      case "insuranceName":
        setLastNameOrder(null);
        setFirstNameOrder(null);
        if (insuranceNameOrder === null) {
          setInsuranceNameOrder(true);
          sortingFunction(["insuranceName", "id"]);
        } else if (insuranceNameOrder) {
          setInsuranceNameOrder(false);
          sortingFunction(["-insuranceName", "id"]);
        } else {
          setInsuranceNameOrder(null);
          sortingFunction(null);
        }
        break;
    }
  };

  return (
    <div className="contentTbl">
      <table className="overview" id="data-table">
        <thead>
          <tr>
            <th style={{ width: "4%" }}>Date Added</th>
            <th
              style={{ width: "9%" }}
              className={
                lastNameOrder === null ? "sortDisable" : lastNameOrder ? "headerSortUp" : "headerSortDown"
              }
            >
              <a href="#" onClick={() => handleSort("lastName")}>
                Last Name
              </a>
            </th>
            <th
              style={{ width: "9%" }}
              className={
                firstNameOrder === null ? "sortDisable" : firstNameOrder ? "headerSortUp" : "headerSortDown"
              }
            >
              <a href="#" onClick={() => handleSort("firstName")}>
                First Name
              </a>
            </th>
            <th style={{ width: "4%" }}>Age</th>
            <th style={{ width: "5%" }}>Gender</th>
            <th style={{ width: "8%" }}>Home Phone</th>
            <th style={{ width: "8%" }}>Mobile Phone</th>
            <th
              style={{ width: "12%" }}
              className={
                insuranceNameOrder === null
                  ? "sortDisable"
                  : insuranceNameOrder
                  ? "headerSortUp"
                  : "headerSortDown"
              }
            >
              <a href="#" onClick={() => handleSort("insuranceName")}>
                Insurance Name
              </a>
            </th>
            <th style={{ width: "7%" }}>Policy #</th>
            <th style={{ width: "9%" }}>Group #</th>
            <th style={{ width: "9%" }}>Subscriber Name</th>
            <th style={{ width: "5%" }}>Subscriber DOB</th>
            <th style={{ width: "10%" }}>Physician</th>
            <th style={{ width: "1%" }}></th>
          </tr>
        </thead>

        {initialLoad ? (
          <Loading colspan={15} />
        ) : data.length > 0 ? (
          <tbody>
            {data.map(({ patient, ...item }, index) => (
              <tr key={item?.id}>
                <td style={{ width: "4%" }}>{new Date(patient?.createdAt).toLocaleDateString()}</td>
                <td style={{ width: "9%" }}>{patient?.family}</td>
                <td style={{ width: "9%" }}>{patient?.name}</td>
                <td style={{ width: "4%" }}>{calculateAge(patient?.dob)}</td>
                <td style={{ width: "5%" }}>{patient?.gender}</td>
                <td style={{ width: "8%" }}>{patient?.homePhone}</td>
                <td style={{ width: "8%" }}>{patient?.mobilePhone}</td>
                <td style={{ width: "12%" }}>{item?.insuranceName}</td>
                <td style={{ width: "7%" }}>{item?.policyNumber}</td>
                <td style={{ width: "9%" }}>{item?.groupNumber}</td>
                <td style={{ width: "9%" }}>{item?.subscriberName}</td>
                <td style={{ width: "5%" }}>{new Date(item?.subscriberDOB).toLocaleDateString()}</td>
                <td style={{ width: "10%" }}>
                  {patient?.followingPhysician
                    ? `${patient?.followingPhysician?.family}, ${patient?.followingPhysician?.name}`
                    : ""}
                </td>
                <td style={{ width: "1%" }}>
                  <div id={`view-btn-${index}`} className="show-options">
                    <a onClick={() => viewDetail(patient?.id)} className="btn">
                      View/Edit
                    </a>
                    {/* <button className="btn btnUrgent">Esign</button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
      {data.length === 0 && !initialLoad ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            fontSize: 18,
          }}
        >
          No patients
        </div>
      ) : null}
    </div>
  );
};

export default InsuranceTable;
